import { configureStore } from "@reduxjs/toolkit";

import Config from "../config";
import { baseApi } from "./api/baseApi";
import authReducer from "./slices/authSlice";
import dataReducer from "./slices/dataSlice";
import newJobFormReducer from "./slices/newJobFormSlice";
import snackbarReducer from "./slices/snackbarSlice";

/**
 * Unified Redux store for the AI Toolkit webapp.
 * This consolidates all previous separate stores (global, notebooks, data-explorer)
 * into a single source of truth.
 */
export const store = configureStore({
  reducer: {
    // RTK Query API reducer
    [baseApi.reducerPath]: baseApi.reducer,
    // Core slices
    auth: authReducer,
    snackbar: snackbarReducer,
    data: dataReducer,
    newJobForm: newJobFormReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(baseApi.middleware),
  devTools: Config.isDev
    ? {
        name: "AI Toolkit",
      }
    : false,
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
